
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'quotes',
	title: 'Quotes'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "api-reference/quotes",
  "id": "api-reference/quotes",
  "isDocsHomePage": false,
  "title": "Quotes",
  "description": "You must fire a GET_QUOTES event before you can retrieve its resulting quotes, learn more here.",
  "source": "@site/docs/api-reference/quotes.md",
  "sourceDirName": "api-reference",
  "slug": "/api-reference/quotes",
  "permalink": "/docs/api-reference/quotes",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "quotes",
    "title": "Quotes"
  },
  "sidebar": "docs",
  "previous": {
    "title": "Product Configs",
    "permalink": "/docs/api-reference/config"
  },
  "next": {
    "title": "Rules",
    "permalink": "/docs/api-reference/rules"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`You must fire a `}<inlineCode parentName="p">{`GET_QUOTES`}</inlineCode>{` event before you can retrieve its resulting quotes, learn more `}<a parentName="p" {...{
        "href": "events/get-quotes"
      }}>{`here`}</a>{`.`}</p>
    <p>{`You can retrieve a list of quotes resulting from a `}<inlineCode parentName="p">{`GET_QUOTES`}</inlineCode>{`event by providing its `}<inlineCode parentName="p">{`triggerRequestId`}</inlineCode>{`.`}</p>
    <div {...{
      "className": "admonition admonition-info alert alert--info"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "14",
              "height": "16",
              "viewBox": "0 0 14 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M7 2.3c3.14 0 5.7 2.56 5.7 5.7s-2.56 5.7-5.7 5.7A5.71 5.71 0 0 1 1.3 8c0-3.14 2.56-5.7 5.7-5.7zM7 1C3.14 1 0 4.14 0 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm1 3H6v5h2V4zm0 6H6v2h2v-2z"
              }}></path></svg></span>{`info`}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`To learn how to fire an event, `}<a parentName="p" {...{
            "href": "fire-event"
          }}>{`click here`}</a>{` for the guide.`}</p></div></div>
    <p><strong parentName="p">{`GET:`}</strong>{` `}<inlineCode parentName="p">{`https://api.{ENV}.dais.com/ioi/v3/quotes/trigger/{triggerRequestId}`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-curl"
      }}>{`curl --location --request GET 'https://api.{ENV}.dais.com/ioi/v3/quotes/trigger/<triggerRequestId>' 
--header 'Authorization: Basic <yourAuthHere>'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "quoted": [
    {
      "requestId": "933bd80a-f4e5-4cda-a8e8-1b981becb3f3",
      "pipelineId": "39232f5e-5c47-4b3d-8a38-d583bd0cf72d",
      "triggerRequestId": "fc55a520-5194-4b6f-b84d-3457f189c5cf",
      "quoteTimestamp": "2022-05-24T19:04:24.1Z",
      "quotingOrganization": "Insurance Co",
      "quoteDetails": {
        "premium": {
          "amount": 3945.0,
          "per": "YEAR"
        },
        "duration": {
          "length": 12,
          "scale": "MONTH"
        },
        "coverageTypes": [
          {
            "coverages": [
              {
                "details": {}
              }
            ]
          }
        ],
        "expirationDate": "2022-06-24T19:04:24.183Z"
      },
      "messages": [],
      "bindable": true,
      "effectiveDate": "2022-05-25",
      "type": "QUOTE",
      "lineId": "3847d175-9ac3-440a-8e53-0e6c54bf6546",
      "lineName": "Product Name",
      "clientId": "c07a0db0-0667-46b1-ad8b-d1a19829f03e",
      "clientOrganizationId": "44677a4c-62ed-40b6-b36f-59bca5088f0c",
      "quotingOrganizationId": "44677a4c-62ed-40b6-b36f-59bca5088f0c",
      "actionId": "5897ad0e-13b2-41b3-9f00-59b4d30eb765",
      "metadata": {
        "rateMeta": {
          "3 Session EAP": "49.08",
          "5 Session EAP": "60.0"
        }
      },
      "rawQuoteRequest": {},
      "rawQuoteDetails": {},
      "asRatingConfiguredAtTimestamp": "2022-05-24T19:04:24.1Z"
    }
  ],
  "declined": []
}
`}</code></pre>
    <p><strong parentName="p">{`Response fields:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`quoted`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Array of quote requests that were successfully quoted`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`declined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Array of quote requests that were declined or failed to quote`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Quote object fields:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`requestId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID representing an individual quote. Use this ID when firing the `}<inlineCode parentName="td">{`PAYMENT_SETUP`}</inlineCode>{` event.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`triggerRequestId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID representing the `}<inlineCode parentName="td">{`GET_QUOTES`}</inlineCode>{` event that generated these quotes.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`pipelineId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`For internal use`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`quoteTimestamp`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Timestamp showing when the quote was generated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`quotingOrganization`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Organization that owns the line`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`quoteDetails`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Quote details returned from the quote request. Explained in detail below`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bindable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Boolean representation of whether the quote is bindable`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`messages`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This field is sometimes used to return errors or other messages`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`effectiveDate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Date when the policy would go into effect if purchased`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`type`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Can be `}<inlineCode parentName="td">{`RATE`}</inlineCode>{` or `}<inlineCode parentName="td">{`QUOTE`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`lineId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID ID of the product for which this quote was generated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`lineName`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Name of the product`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`clientId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID ID of the client on whose behalf the quote was requested`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`clientOrganizationId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID ID of the organization requesting the quote`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`quotingOrganizationId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UUID ID of the organization providing the quote. This will be the same as `}<inlineCode parentName="td">{`clientOrganizationId`}</inlineCode>{` if you use our Excel`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`actionId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`For internal use`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`metadata`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Quote metadata`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`asRatingConfiguredAtTimestamp`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Timestamp of the rating configuration used to generate the quote`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Quote details fields:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`premium`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Quoted policy premium`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`duration`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Quoted policy duration`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`coverageTypes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Coverages included in the quote`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`expirationDate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Timestamp after which the quote will no longer be valid`}</td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
